import { render, staticRenderFns } from "./boutBallBetInfo.vue?vue&type=template&id=29e1d9e8&scoped=true"
import script from "./boutBallBetInfo.vue?vue&type=script&lang=js"
export * from "./boutBallBetInfo.vue?vue&type=script&lang=js"
import style0 from "./boutBallBetInfo.vue?vue&type=style&index=0&id=29e1d9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e1d9e8",
  null
  
)

export default component.exports